import { FC } from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	margin-right: 12px;

	svg {
		width: 24px;
		height: 24px;
	}

	@media (max-width: 700px) {
		width: 28px;
		height: 28px;
		margin-right: 8px;

		svg {
			width: 20px;
			height: 20px;
		}
	}
`

interface CardIconProps {
	type: 'robux' | 'money' | 'rate' | 'total' | 'preorders'
}

const CardIcon: FC<CardIconProps> = ({ type }) => {
	const renderIcon = () => {
		switch (type) {
		case 'robux':
			return (
				<svg
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<defs>
						<linearGradient id='robuxGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
							<stop
								offset='0%'
								style={{ stopColor: '#6366f1', stopOpacity: 1 }}
							/>
							<stop
								offset='100%'
								style={{ stopColor: '#8b5cf6', stopOpacity: 1 }}
							/>
						</linearGradient>
					</defs>
					<path d='M12 2L2 7L12 12L22 7L12 2Z' fill='url(#robuxGradient)' />
					<path
						d='M2 17L12 22L22 17'
						stroke='url(#robuxGradient)'
						strokeWidth='2'
						fill='none'
					/>
					<path
						d='M2 12L12 17L22 12'
						stroke='url(#robuxGradient)'
						strokeWidth='2'
						fill='none'
					/>
					<circle cx='12' cy='7' r='2' fill='white' />
					<text
						x='12'
						y='9'
						textAnchor='middle'
						fill='url(#robuxGradient)'
						fontSize='8'
						fontWeight='bold'
					>
							R$
					</text>
				</svg>
			)
		case 'money':
			return (
				<svg
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<defs>
						<linearGradient id='moneyGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
							<stop
								offset='0%'
								style={{ stopColor: '#f59e0b', stopOpacity: 1 }}
							/>
							<stop
								offset='100%'
								style={{ stopColor: '#d97706', stopOpacity: 1 }}
							/>
						</linearGradient>
					</defs>
					<circle cx='12' cy='12' r='10' fill='url(#moneyGradient)' />
					<circle
						cx='12'
						cy='12'
						r='7'
						fill='none'
						stroke='white'
						strokeWidth='1.5'
					/>
					<path
						d='M10.5 8.5C10.5 7.67 11.17 7 12 7C12.83 7 13.5 7.67 13.5 8.5C13.5 9.33 12.83 10 12 10C11.17 10 10.5 10.67 10.5 11.5C10.5 12.33 11.17 13 12 13C12.83 13 13.5 13.67 13.5 14.5C13.5 15.33 12.83 16 12 16'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
					/>
					<path
						d='M12 6V7M12 16V17'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
					/>
				</svg>
			)
		case 'rate':
			return (
				<svg
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<defs>
						<linearGradient id='rateGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
							<stop
								offset='0%'
								style={{ stopColor: '#10b981', stopOpacity: 1 }}
							/>
							<stop
								offset='100%'
								style={{ stopColor: '#059669', stopOpacity: 1 }}
							/>
						</linearGradient>
					</defs>
					<rect x='3' y='4' width='18' height='16' rx='2' fill='url(#rateGradient)' />
					<path
						d='M7 8L17 8M7 12L17 12M7 16L13 16'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
					/>
					<path
						d='M15 14L17 16L19 14'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<circle cx='17' cy='10' r='2' fill='white' />
					<path
						d='M16 9.5L17.5 11L18.5 9.5'
						stroke='url(#rateGradient)'
						strokeWidth='1'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			)
		case 'total':
			return (
				<svg
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<defs>
						<linearGradient id='totalGradient' x1='0%' y1='0%' x2='100%' y2='100%'>
							<stop
								offset='0%'
								style={{ stopColor: '#3b82f6', stopOpacity: 1 }}
							/>
							<stop
								offset='100%'
								style={{ stopColor: '#1d4ed8', stopOpacity: 1 }}
							/>
						</linearGradient>
					</defs>
					<rect
						x='3'
						y='3'
						width='18'
						height='18'
						rx='3'
						fill='url(#totalGradient)'
					/>
					<path
						d='M8 8L16 8M8 12L16 12M8 16L12 16'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
					/>
					<circle cx='15' cy='16' r='2' fill='white' />
					<path
						d='M14.2 15.2L15.8 16.8M14.2 16.8L15.8 15.2'
						stroke='url(#totalGradient)'
						strokeWidth='1.5'
						strokeLinecap='round'
					/>
					<path
						d='M18 6L20 8L18 10'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			)
		case 'preorders':
			return (
				<svg
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<defs>
						<linearGradient
							id='preordersGradient'
							x1='0%'
							y1='0%'
							x2='100%'
							y2='100%'
						>
							<stop
								offset='0%'
								style={{ stopColor: '#8b5cf6', stopOpacity: 1 }}
							/>
							<stop
								offset='100%'
								style={{ stopColor: '#7c3aed', stopOpacity: 1 }}
							/>
						</linearGradient>
					</defs>
					<circle cx='12' cy='12' r='10' fill='url(#preordersGradient)' />
					<circle
						cx='12'
						cy='12'
						r='7'
						fill='none'
						stroke='white'
						strokeWidth='1.5'
					/>
					<path
						d='M12 7V12L15 15'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<circle cx='12' cy='12' r='1' fill='white' />
					<path
						d='M12 3V5M21 12H19M12 19V21M5 12H3'
						stroke='white'
						strokeWidth='1'
						strokeLinecap='round'
					/>
				</svg>
			)
		default:
			return null
		}
	}

	return <IconWrapper>{renderIcon()}</IconWrapper>
}

export default CardIcon
